export default __webpack_public_path__ + "static/media/warning--bicycles-caution-on-rail-tracks--g1.24127b37.png";